module.exports = global["$"] = require("-!C:\\wamp64\\www\\micromuneemandroid2\\node_modules\\expose-loader\\index.js?jQuery!.\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/expose-loader?jQuery!./~/jquery/dist/jquery.js-exposed
// module id = 484
// module chunks = 1